/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyServiceVersionDto
 */
export interface VerifyServiceVersionDto {
    /**
     * The YAML definition.
     * @type {string}
     * @memberof VerifyServiceVersionDto
     */
    definition: string;
    /**
     * The environment settings.
     * @type {{ [key: string]: string; }}
     * @memberof VerifyServiceVersionDto
     */
    environment: { [key: string]: string; };
}

/**
 * Check if a given object implements the VerifyServiceVersionDto interface.
 */
export function instanceOfVerifyServiceVersionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "definition" in value;
    isInstance = isInstance && "environment" in value;

    return isInstance;
}

export function VerifyServiceVersionDtoFromJSON(json: any): VerifyServiceVersionDto {
    return VerifyServiceVersionDtoFromJSONTyped(json, false);
}

export function VerifyServiceVersionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyServiceVersionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'definition': json['definition'],
        'environment': json['environment'],
    };
}

export function VerifyServiceVersionDtoToJSON(value?: VerifyServiceVersionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'definition': value.definition,
        'environment': value.environment,
    };
}

